import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'

const GET_OPEN_AFTER = gql`
  query OpenAfter($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0
      filters: $filters
      aggs: { OpenAfter: { terms: { field: "pharmacyOpenAfter.keyword" } } }
    ) {
      aggregations
    }
  }
`

const OpenAfter = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_OPEN_AFTER,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const openAfterPharmacy = data.pharmaciesAggs.aggregations.OpenAfter?.buckets[0]?.key === 'fechado após 19h' ? 'Não' : 'Sim'

  return (
    <CardWidget
      title="Atendendo após 19:00h"
      number={openAfterPharmacy}
      color={Colors.blue}
    />
  )
}

export default OpenAfter
